import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

//tme-track
const Time = () => import('@/views/tme-track/Time')
const Materials = () => import('@/views/tme-track/Materials')
const Expense = () => import('@/views/tme-track/Expense')
const Projects = () => import('@/views/tme-track/Projects')
const Employees = () => import('@/views/tme-track/Employees')
const Profile = () => import('@/views/tme-track/Profile')
const Subscription = () => import('@/views/tme-track/Subscription')
const ProjectReports = () => import('@/views/tme-track/ProjectReports')
const TimeReports = () => import('@/views/tme-track/TimeReports')
const Portfolio = () => import('@/views/tme-track/Portfolio')
const Business = () => import('@/views/tme-track/Business')

//pages
const Signin = () => import('@/views/pages/Signin')
const Signup = () => import('@/views/pages/Signup')
const Signout = () => import('@/views/pages/Signout')
const Forgot = () => import('@/views/pages/Forgot')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/projects',
      name: 'Home',
      component: DefaultContainer,
      children: [
		{
		  path: 'time',
		  name: 'Time',
		  component: Time
		},
		{
		  path: 'materials',
		  name: 'Materials',
		  component: Materials
		},
		{
		  path: 'expense',
		  name: 'Expense',
		  component: Expense
		},
		{
		  path: 'projects',
		  name: 'Projects',
		  component: Projects
		},
		{
		  path: 'projects/:id',
		  name: 'Projects with ID',
		  component: Projects
		},
		{
		  path: 'employees',
		  name: 'Employees',
		  component: Employees
		},
		{
		  path: 'profile',
		  name: 'Profile',
		  component: Profile
		},
		{
		  path: 'subscription',
		  name: 'Subscription',
		  component: Subscription
		},
		{
		  path: 'project-reports',
		  name: 'Project Reports',
		  component: ProjectReports
		},
		{
		  path: 'time-reports',
		  name: 'Time Reports',
		  component: TimeReports
		},
		{
		  path: 'portfolio',
		  name: 'Portfolio',
		  component: Portfolio
		},
		{
		  path: 'business',
		  name: 'Business',
		  component: Business
		}
      ]
    },
	{
	  path: '/signin',
	  name: 'Sign In',
	  component: Signin
	},
	{
	  path: '/signup',
	  name: 'Sign Up',
	  component: Signup
	},
	{
	  path: '/signout',
	  name: 'Sign Out',
	  component: Signout
	},
	{
	  path: '/forgot',
	  name: 'Forgot',
	  component: Forgot
	}

  ]
})
